// src/pages/CompetitionSuccess.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CompetitionSuccess.css';

const CompetitionSuccess = () => {
  const navigate = useNavigate();

  const goViewPost = () =>
    navigate('/grid', { state: { activeTab: 'competition' } });
  const goHome = () => navigate('/HomeScreen');

  const enteredOn = new Date().toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  return (
    <div className="csuccess-page">
      <main className="csuccess-ticket">
        <div className="csuccess-ticket-top">
          <span className="csuccess-stamp" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="26" height="26">
              <path
                d="M4 12.5L9.5 18L20 6.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>

          <h1 className="csuccess-heading">
            You did it — your idea is officially entered.
          </h1>

          <p className="csuccess-message">
            It's in great hands now. Our reviewers will read every word of it
            closely, judging it fairly and thoroughly, purely on its own
            merit. Take a breath — you've already done the hardest part.
          </p>

          <p className="csuccess-timestamp">Entered on {enteredOn}</p>
        </div>

        <div className="csuccess-perforation" aria-hidden="true"></div>

        <div className="csuccess-ticket-bottom">
          <button className="csuccess-primary-btn" onClick={goViewPost}>
            See it on the board
          </button>
          <button className="csuccess-secondary-btn" onClick={goHome}>
            Back to home
          </button>
        </div>
      </main>
    </div>
  );
};

export default CompetitionSuccess;